export default __webpack_public_path__ + "images/PI.27b6cba.png";